import React, { useState } from "react";
import { TextInputField, Button, DropDownField } from "../../../helpers";

import { sortArrayOfObjectsInAlphabeticalOrder, validateInputs, combineISDCodeWithPhoneNumber } from '../../../utils'

import { companyInitialState, addNewCompanySchema } from '../../../validation/postRequirementValidation'
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { verifyGSTINsByPanNumber } from "../../../services/api/company";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

function AddNewCompany(props) {

    const [companyDetails, setCompanyDetails] = useState(companyInitialState)
    const [formErrors, setFormErrors] = useState([])
    const [urpCheck, setUrpCheck] = useState(false)
    const [isGSTINDataLoading, setIsGSTINDataLoading] = useState(false)
    const [companyGSTINs, setCompanyGSTINs] = useState([])
    const [isPanVerified, setIsPanVerified] = useState(false)
    // const [isLoading, setIsLoading] = useState(false)

    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const { 
        stateList, 
        handleAddNewCompanySubmit,
        setIsLoading,
        pinCodesData,
        countriesData
    } = props

    const dispatch = useDispatch()

    const handleVerifyClick = async () => {
        setIsGSTINDataLoading(true)

        const response = await verifyGSTINsByPanNumber(companyDetails.panCode)
        console.log("response verify gstins", response)
        if (response?.failure){
            setIsGSTINDataLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: response?.data?.error, life: 3000 }))
        }else{
            let sortedGSTINsVerification = sortArrayOfObjectsInAlphabeticalOrder(response?.data?.verification, "gstin")
            let updatedGSTINs = sortedGSTINsVerification?.map(eachVerifiedGSTIN => {
                return {...eachVerifiedGSTIN, gstinCode : eachVerifiedGSTIN?.gstin }
            })

            setIsPanVerified(true)
            setCompanyGSTINs(updatedGSTINs)
            setIsGSTINDataLoading(false)
        }
    }

    const handleChange = (e) => {
        companyDetails[e.target.name] = e.target.value

        if(e.target.name === "pinCode" && (e.target.value).length === pmCompanyConfig.pinCodeLength){
            const relatedPinCode = pinCodesData?.find(eachPincode => {
                if(eachPincode.pinCode === parseInt(e.target.value)){
                    return eachPincode
                }
            })

            if(relatedPinCode?.stateId || pmCompanyConfig.isInternational){
                if (!pmCompanyConfig.isInternational){
                    const relatedState = stateList.find(eachState => {
                        if(eachState.stateId === relatedPinCode.stateId){
                            companyDetails["stateId"] = eachState?.stateId
                            return true
                        }
                        return false
                    })

                    countriesData.find(eachCountry => {
                        if(eachCountry.countryId === relatedState?.countryId){
                            companyDetails["countryId"] = eachCountry?.countryId
                            return true
                        }
                        return false
                    })
                } else{
                    companyDetails["stateId"] = pmCompanyConfig.defaultStateId
                    companyDetails["countryId"] = pmCompanyConfig.defaultCountryId
                }
            }else{
                return dispatch(raiseToast({severity:'warn', detail: "Please enter valid pincode", life: 3000}))
            }
        }else{
            if(e.target.name === "pinCode"){
                companyDetails["stateId"] = null
                companyDetails["countryId"] = null
            }
        }
        setCompanyDetails({...companyDetails})
    }

    const handleCompanyValidations = async (e) => {
        // companyDetails.urpCheck = urpCheck

        const validation_res = await validateInputs(addNewCompanySchema, companyDetails, pmCompanyConfig)

        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
            }
            else if(!isPanVerified && validation_res.result.panCode){
                return dispatch(raiseToast({severity:'warn', detail: "Please verify pan code", life: 3000}))
            }
            else {

                validation_res.result.isPanVerified  = isPanVerified
                if(isPanVerified){
                    const selectedGSTIN = companyGSTINs.find(eachGSTIN => eachGSTIN.gstinCode === companyDetails?.gstinCode)
                    console.log("selectedGSTIN", selectedGSTIN)
                    
                    const relatedState = stateList.find(eachState => {
                        console.log("state", eachState.stateId, parseFloat(selectedGSTIN?.gstinCode?.slice?.(0,2)))
                        return eachState.stateId === parseFloat(selectedGSTIN?.gstinCode?.slice?.(0,2))
                    })
                    console.log("relatedState", relatedState)

                    validation_res.result.gstinVerifiedObj = selectedGSTIN
                    validation_res.result.companyGSTINs = companyGSTINs
                    if(relatedState){
                        validation_res.result.gstinVerifiedObj.stateId = relatedState?.stateId ? relatedState?.stateId : null
                    }
                }

                let urpCheck = true
                if(isPanVerified && validation_res.result.gstinVerifiedObj){ 
                    urpCheck = false
                }

                validation_res.result.hodPhoneNo = combineISDCodeWithPhoneNumber(validation_res.result.hodISDCode, validation_res.result.hodPhoneNo)

                setFormErrors({})
                // setCompanyDetails(companyInitialState)
                setIsLoading(true)

                handleAddNewCompanySubmit(validation_res.result, urpCheck)
            }
        }
    }

    return (
        <>
            <div className="">
                {/* <div className="flex align-items-center ml-2">
                    <InputSwitch name="" checked={urpCheck} onChange={(e) => setUrpCheck(e.value)} />
                    <p className="ml-3">URP</p>
                </div> */}
                <div className="flex flex-column md:flex-row">
                    <div className="flex flex-column col-12 md:col-4">
                        <TextInputField name="companyName" value={companyDetails.companyName} labelText='Company Name' placeholder="" onChange={handleChange} errorMessage={formErrors.companyName} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="branchName" value={companyDetails.branchName} labelText='Branch' placeholder="" onChange={handleChange} errorMessage={formErrors.branchName} required />
                    </div>
                    {/* {!urpCheck && 
                        <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                            <TextInputField name="gstinCode" value={companyDetails.gstinCode} labelText='GSTIN' placeholder="" onChange={handleChange} errorMessage={formErrors.gstinCode} />
                        </div>
                    } */}
                </div>
                {
                    pmCompanyConfig.isInternational ?
                    null 
                    :
                    <div className="flex flex-row flex-wrap align-items-center">
                        <div className="flex flex-row col-12 md:col-4">
                            <div className="flex flex-column col-9 py-0 pl-0">
                                <TextInputField name="panCode" value={companyDetails.panCode} labelText='Pan Code (optional)' placeholder="" onChange={handleChange} errorMessage="" disabled={isPanVerified} />
                            </div>
                            <div className=" flex flex-column align-items-center">
                                {
                                    isPanVerified ? <label className="text-xs mt-4" style={{ color: "green" }}>Verified!</label> :
                                    <Button className="w-4rem mt-3 ml-2 md:ml-0" label="Verify" loading={isGSTINDataLoading} disabled={companyDetails.panCode.length !== 10} onClick={handleVerifyClick} /> 
                                }
                            </div>
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <DropDownField name="gstinCode" labelText="GSTIN (optional)" value={companyDetails.gstinCode} options={companyGSTINs} optionLabel="gstinCode"  optionValue="gstinCode" {...(isGSTINDataLoading ? { loading: true, disabled: true } : {})}  onChange={(event) => handleChange(event)} />
                        </div>
                    </div>
                }
                <div className="flex flex-row flex-wrap">
                    <div className="flex flex-column col-12 md:col-4">
                        <TextInputField name="hodFirstName" value={companyDetails.hodFirstName} labelText='First Name' placeholder="" onChange={handleChange} errorMessage={formErrors.hodFirstName} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-4">
                        <TextInputField name="hodLastName" value={companyDetails.hodLastName} labelText='Last Name' placeholder="" onChange={handleChange} errorMessage={formErrors.hodLastName} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-4">
                        <TextInputField name="hodEmail" value={companyDetails.hodEmail} labelText='Email' placeholder="" onChange={handleChange} errorMessage={formErrors.hodEmail} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-1">
                        <DropDownField name="hodISDCode" labelText="ISD Code" options={countriesData} optionLabel="ISDCode" optionValue="ISDCode" value={companyDetails.hodISDCode } onChange={handleChange} errorMessage={formErrors.hodISDCode} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-3">
                        <TextInputField name="hodPhoneNo" value={companyDetails.hodPhoneNo} labelText='Mobile' placeholder="" onChange={handleChange} keyfilter="int" errorMessage={formErrors.hodPhoneNo} maxLength={10} required />
                    </div>
                </div>
                <div className="hr-line"></div>
                <h4 className="m-3 ml-1"> Shipping Address</h4>
                <div className="grid">
                    <div className="flex flex-column col-12 md:col-8">
                        <TextInputField name="address" value={companyDetails.address} labelText='Address Line' placeholder="" onChange={handleChange} errorMessage={formErrors.address} required />
                    </div>
                    {/* <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                        <TextInputField name="addressLine2" value={companyDetails.addressLine2} labelText='Address Line 2' placeholder="" onChange={handleChange}  errorMessage={formErrors.addressLine2} required />
                    </div> */}
                    <div className="flex flex-column col-12 md:col-4">
                        <TextInputField name="pinCode" value={companyDetails.pinCode} labelText='Pin Code' placeholder="" onChange={handleChange} keyfilter="int" errorMessage={formErrors.pinCode} maxLength={6} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-4">
                        <TextInputField name="city" value={companyDetails.city} labelText='City' onChange={handleChange} errorMessage={formErrors.city} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-4">
                        <DropDownField name="stateId" labelText="State" options={stateList} optionLabel="stateName" optionValue="stateId" value={companyDetails.stateId} onChange={handleChange} errorMessage={formErrors.stateId} disabled required />
                    </div>
                    <div className="flex flex-column col-12 md:col-4">
                        <DropDownField name="countryId" labelText="Country" options={countriesData} optionLabel="countryName" optionValue="countryId" value={companyDetails.countryId} onChange={handleChange} errorMessage={formErrors.countryId} disabled />
                    </div>
                </div>
                <div className="mt-2 text-center">
                    <Button label="Add New Company" type="submit" onClick={handleCompanyValidations}/>
                </div>
                    {/* <Loading visible={isLoading} /> */}
            </div>
        </>
    )
}

export default AddNewCompany;